import { render, staticRenderFns } from "./ShowSuspension.vue?vue&type=template&id=ceec1e98&scoped=true&"
import script from "./ShowSuspension.vue?vue&type=script&lang=js&"
export * from "./ShowSuspension.vue?vue&type=script&lang=js&"
import style0 from "./ShowSuspension.vue?vue&type=style&index=0&id=ceec1e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec1e98",
  null
  
)

export default component.exports